var busDriverLandingspage = {
    $busDriverLandingspage: $('.bus-driver-landingspage-block'),

    init: function() {
        var _this = this;

        console.log(googleMap);
        _this.$form = _this.$busDriverLandingspage.find('.code-form');
        _this.$input = $('input');
        _this.$validateBtn = _this.$busDriverLandingspage.find('.btn.validate');
        _this.$formBlock = _this.$busDriverLandingspage.find('.form-block');
        _this.$hiddenBeforeSubmit = _this.$busDriverLandingspage.find('.hide-before-submit');
        _this.$tableBody = _this.$busDriverLandingspage.find('.table-block .table tbody');

        if (!_this.$busDriverLandingspage.length) {
            return;
        }

        _this.listener();
    },

    listener: function() {
        var _this = this;

        _this.$form.submit(function(e) {
            e.preventDefault;
            _this.codeValidation();
            return false;
        });

        _this.$validateBtn.on('click', function(e) {
            e.preventDefault;

            _this.codeValidation();
        });
    },

    codeValidation: function() {
        var _this = this;

        _this.$form.validate({
            rules: {
                bus_driver_code: {
                    required: true
                }
            }
        });

        // Checking if the form is valid
        if (_this.$form.valid()) {
            // Serialize form
            var formData = _this.$form.serialize();

            // Ajax call to validate the code
            $.ajax({
                url: window.baseUrl + '/wp-admin/admin-ajax.php',
                data: formData,
                type: 'post',
                dataType: 'JSON',
                success: function(response) {
                    var x = response.data.data.length;
                    var newArray = response.data.data.sort(function(a, b) {
                        return a.departure.localeCompare(b.departure);
                    });
                    for (i = 0; i < x; i++) {
                        $('.table-block .table tbody').append(
                            `<tr>
                                <td>${newArray[i].order_id}</td>
                                <td>${newArray[i].first_name}</td>
                                <td>${newArray[i].last_name}</td>
                                <td>${newArray[i].event_name}</td>
                                <td>${newArray[i].ticket_type}</td>
                                <td>${newArray[i].departure}</td>
                                <td>${newArray[i].phone_number}</td>
                            </tr>`
                        );
                    }

                    $('.route-block-driver-page').addClass('route-block');
                    googleMap.$routeBlock = $('.route-block');
                    googleMap.init();
                    // $(googleMap.$routeBlock[1]).googleMap.init();

                    $('.event-name').html(`${response.data.route.route_name}`);
                    $('.driver-name').html(`${response.data.route.busbaas}`);
                    $('.driver-number').html(`${response.data.route.busbaas_number}`);

                    $('.hide-before-submit').addClass('active');
                    _this.$busDriverLandingspage.removeClass('active');
                },
                error: function(response) {
                    _this.$busDriverLandingspage.addClass('active');
                    $('.hide-before-submit').removeClass('active');
                }
            });
        }
    }
};
